module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0059.bc36902c.jpg";